<template>
  <div>
    <el-card
      v-loading="loading"
      class="card-container"
      shadow="never"
    >
      <el-row
        slot="header"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <div>
          <h1 class="card-container__title">
            Trang chủ
          </h1>
        </div>
      </el-row>
      <div>
        <el-row
          :gutter="24"
          class="mb-xl"
          type="flex"
          align="middle"
          justify="center"
        >
          <el-col
            :lg="8"
            :span="12"
          >
            <el-card
              class="w-100 text-center"
            >
              <h3 class="text-xl mb-xs">
                Tổ chức
              </h3>
              <h2 class="text-primary">
                {{ dashboard.organization }}
              </h2>
            </el-card>
          </el-col>
          <el-col
            :lg="8"
            :span="12"
          >
            <el-card class="w-100 text-center">
              <h3 class="text-xl mb-xs">
                Tài khoản
              </h3>
              <h2 class="text-primary">
                {{ dashboard.account }}
              </h2>
            </el-card>
          </el-col>
        </el-row>
        <el-row
          :gutter="24"
          class="mb-xl"
          type="flex"
          align="middle"
          justify="center"
        >
          <el-col
            :lg="8"
            :span="12"
          >
            <el-card class="w-100 text-center">
              <h3 class="text-xl mb-xs">
                Đối tượng
              </h3>
              <h2 class="text-primary">
                {{ dashboard.object }}
              </h2>
            </el-card>
          </el-col>
          <el-col
            :lg="8"
            :span="12"
          >
            <el-card class="w-100 text-center">
              <h3 class="text-xl mb-xs">
                Danh mục
              </h3>
              <h2 class="text-primary">
                {{ dashboard.category }}
              </h2>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import dashboardServices from '../../services/dashboard';

export default {
  name: "Dashboard",
  data() {
    return {
      loading: false,
      dashboard: {
        account: 0,
        organization: 0,
        object: 0,
        category: 0
      }
    }
  },
  beforeMount() {
    this.initData()
  },
  methods: {
    initData() {
      this.loading = true;
      dashboardServices.get().then((response) => {
        this.dashboard = response
      }).finally(() => {
        this.loading = false;
      })
    }
  }
};
</script>

<style lang="scss" scoped></style>
